export const isExists = (v) => v !== undefined;
export const isDiff = (a, b) => a.some((v, i) => v !== b[i]);
